"use client";

import type { ReactNode } from "react";
import { Panchang } from "@/components/panchang";
import RatingPrompt from "@/components/RatingPrompt";
import { DEFAULT_PANCHANG_CITY, PanchangCityProvider } from "@/contexts/PanchangCity";
import type { PanchangResponse } from "@/lib/api/panchang";
import type { CityData } from "@/lib/cities-data.types";

export default function PanchangClient({
  latitude = 28.6139,
  longitude = 77.209,
  defaultLanguage = "en",
  initialDate,
  initialDisplayDate,
  initialResult,
  initialCity = DEFAULT_PANCHANG_CITY,
  allowCityChange = true,
  resultOffer,
  crossLinks,
}: {
  latitude?: number;
  longitude?: number;
  defaultLanguage?: "en" | "hi";
  initialDate?: string;
  initialDisplayDate?: string;
  initialResult?: PanchangResponse | null;
  initialCity?: CityData;
  allowCityChange?: boolean;
  resultOffer: ReactNode;
  crossLinks: ReactNode;
}) {
  return (
    <>
      <div className="intent-interface-timing-first min-h-[calc(100vh-130px)]">
        <PanchangCityProvider
          initialCity={{
            ...initialCity,
            latitude,
            longitude,
          }}
          restoreStoredCity={allowCityChange}
        >
          <Panchang
            language={defaultLanguage}
            initialDate={initialDate}
            initialDisplayDate={initialDisplayDate}
            initialResult={initialResult}
            initialCity={initialCity}
            allowCityChange={allowCityChange}
            resultOffer={resultOffer}
            crossLinks={crossLinks}
          />
        </PanchangCityProvider>
      </div>
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "0 16px 24px" }}>
        <RatingPrompt
          source={"tool_result" as never}
          mode="thumbs+text"
          prompt="Was today's Panchang accurate?"
          context={{
            surface: "panchang_result",
            path: typeof window !== "undefined" ? window.location.pathname : null,
          }}
        />
      </div>
    </>
  );
}
